(function(){
  function reveal(root){
    var els=(root||document).querySelectorAll('.rl-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');count(e);});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');count(x.target);io.unobserve(x.target);}});
    },{threshold:.15,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  function count(root){
    var nodes=root.querySelectorAll('[data-rl-count]');
    nodes.forEach(function(n){
      if(n.__rlDone)return;n.__rlDone=1;
      var t=parseFloat(n.getAttribute('data-rl-count'));if(isNaN(t))return;
      var dec=(String(n.getAttribute('data-rl-count')).split('.')[1]||'').length,start=null;
      function fmt(v){return v.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
      function step(ts){if(!start)start=ts;var p=Math.min(1,(ts-start)/1500),e=1-Math.pow(1-p,3);n.textContent=fmt(t*e);if(p<1)requestAnimationFrame(step);else n.textContent=fmt(t);}
      requestAnimationFrame(step);
    });
  }
  function init(){reveal(document);setTimeout(function(){document.querySelectorAll('.rl-reveal:not(.is-in)').forEach(function(e){var r=e.getBoundingClientRect();if(r.top<window.innerHeight){e.classList.add('is-in');count(e);}});},2500);}
  if(window.__rlInit){return;}window.__rlInit=1;
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();
